import React from "react";
import arrowRight from "../../../assets/images/arrow-right.svg";
import dayjs from "dayjs";
import { Patient } from "../../../types";
import { getInitials } from "../../../utils/helper";
import { useNavigate } from "react-router-dom";
import { PAID, PENDING, PLAN_STATUS_MAP } from "../../../utils/constants";

interface PatientCardProps {
  patient: Patient;
}

const PatientCard: React.FC<PatientCardProps> = ({ patient }) => {
  const navigate = useNavigate();
  const mappedStatus =
    PLAN_STATUS_MAP[patient?.referral_status as keyof typeof PLAN_STATUS_MAP];

  return (
    <article
      className="flex overflow-hidden flex-col p-4 mt-4 w-full bg-white rounded-3xl shadow-[0px_1px_16px_rgba(0,0,0,0.04)]"
      onClick={() => navigate(`/patient-details`, { state: patient })}
    >
      <div className="flex gap-3 justify-center items-start w-full">
        <div className="flex flex-1 shrink gap-3 items-center basis-0 min-w-[240px]">
          <div className="overflow-hidden self-stretch my-auto w-12 h-12 text-lg font-semibold leading-none text-purple-500 whitespace-nowrap bg-violet-50 min-h-[48px] rounded-[80px] flex items-center justify-center">
            {patient.name ? getInitials(patient.name) : ""}
          </div>
          <div className="flex flex-col flex-1 shrink self-stretch my-auto basis-0 text-left">
            <h3 className="text-base font-semibold text-gray-800">
              {patient.name}
            </h3>
            <p className="mt-1 text-sm leading-loose text-gray-700">
              {patient.medical_condition_name}
            </p>
          </div>
        </div>
        <img
          loading="lazy"
          src={arrowRight}
          className="object-contain shrink-0 w-[24px] h-[24px] rounded-3xl aspect-square bg-[#4B4AD5]"
          alt=""
        />
      </div>
      <hr className="mt-4 w-full min-h-[1px]" />
      <footer className="flex gap-4 items-center mt-4 w-full text-xs">
        <div className="flex flex-1 shrink gap-0.5 items-center self-stretch my-auto text-gray-500 basis-6">
          <span className="self-stretch my-auto">Referred on:</span>
          <time className="self-stretch my-auto font-semibold leading-none">
            {patient.created_at
              ? dayjs(patient.created_at).format("DD MMM YYYY")
              : ""}
          </time>
        </div>
        {mappedStatus && (
          <div
            className={`overflow-hidden gap-2 self-stretch px-3 py-1 my-auto font-medium rounded-3xl ${
              patient.referral_status === PENDING
                ? "text-orange-400 bg-orange-100"
                : patient.referral_status === PAID
                ? "text-[#1F8B24] bg-[#C5F2C7]"
                : "text-[#DA100B] bg-[#FCD0CF]"
            }`}
          >
            {mappedStatus}
          </div>
        )}
      </footer>
    </article>
  );
};

export default PatientCard;
